import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=ed64e624&scoped=true&"
import script from "./Site.vue?vue&type=script&lang=js&"
export * from "./Site.vue?vue&type=script&lang=js&"
import style0 from "./Site.vue?vue&type=style&index=0&id=ed64e624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64e624",
  null
  
)

export default component.exports